import { Link } from 'react-router-dom'
import { all_routes } from '../../router/all_routes'
import ImageWithBasePath from '../../../core/common/imageWithBasePath'

const EmailVerification = () => {
  const route = all_routes

  return (
    <>
      {/* Main Wrapper */}
      <div className="main-wrapper">
        <div className="login-content">
          <div className="row">
            {/* Login Banner */}
            <div className="col-md-6 login-bg d-none d-lg-flex p-5">
              <div className="login-carousel-section mb-3">
                <div className="login-banner">
                  <ImageWithBasePath
                    src="/assets/img/login.webp"
                    className="img-fluid"
                    alt="Logo"
                  />
                </div>
                <div
                  className="mentor-course text-center mt-5"
                  style={{ color: '#1E344C' }}
                >
                  <h3 className="mb-2" style={{ color: '#1E344C' }}>
                    Assalamu’alaikum,
                    <br />
                    <span className="" style={{ color: '#1E344C' }}>
                      Welcome to Jadipraktisi!
                    </span>
                  </h3>
                  <p className="" style={{ color: '#1E344C' }}>
                    Bismillah, perjalanan karirmu akan dimulai dari sini, masuk
                    sekarang!
                  </p>
                </div>
              </div>
            </div>
            {/* /Login Banner */}
            <div className="col-md-6 login-wrap-bg">
              {/* Login */}
              <div className="login-wrapper">
                <div className="loginbox">
                  <div className="w-100">
                    <div className="d-flex align-items-center justify-content-between login-header">
                      <Link to={route.home} className="link-1">
                        <ImageWithBasePath
                          src="/assets/img/logo-color.webp"
                          className="img-fluid"
                          alt="Logo"
                          width={250}
                        />
                      </Link>
                    </div>
                    <div className="topic text-center">
                      <div className="mb-4">
                        <i
                          className="isax isax-sms text-success"
                          style={{ fontSize: '4rem' }}
                        />
                      </div>
                      <h1 className="fs-32 fw-bold mb-3">
                        Silakan periksa email anda
                      </h1>
                      <p className="fs-14 fw-normal mb-0">
                        Kami telah mengirimkan link reset password ke email
                        anda. Silakan cek inbox atau folder spam anda.
                      </p>
                    </div>
                    <div className="d-grid mt-4">
                      <Link
                        to={route.login}
                        className="btn btn-secondary btn-lg"
                      >
                        Kembali ke Login
                        <i className="isax isax-arrow-right-3 ms-1" />
                      </Link>
                    </div>
                    <p className="fs-14 fw-normal d-flex align-items-center justify-content-center mt-3">
                      Belum menerima email?
                      <Link to={route.forgotpassword} className="link-2 ms-1">
                        {' '}
                        Kirim ulang
                      </Link>
                    </p>
                    {/* /Login */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Main Wrapper */}
    </>
  )
}

export default EmailVerification
